<div class="app-form-events-modal">
  <div class="modal-header">
    <h3 class="modal-title m-0">{{ title }}</h3>
  </div>
  <div class="modal-body">
    @for (field of mappedFieldToFormItems$(); track $index) {
      <div class="row">
        <div class="col-md-12 app-form-events-modal__body__col">
          <app-office-form-control [formGroupInstance]="eventsForm" [officeField]="field"></app-office-form-control>
        </div>
      </div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="confirm()">Ok</button>
    <button type="button" class="btn btn-outline-primary" (click)="close()">Close</button>
  </div>
</div>
